import type { Notification } from 'src/context/api/data/api';
import { filterByType } from './notifications.utils';
import { BRAND_INFRINGEMENT_NOTIFICATIONS_ENABLED } from './brand-infringement-alerts';

// The types the bell has a card for. Everything else stays out: onboarding
// notifications were withdrawn from it, finished exports download themselves
// with a toast (see the auto-download effect in notifications-popover.tsx),
// and untyped rows are legacy job notifications that never expire, shown as a
// toast when they arrive (use-notifications.tsx).
const LISTED_TYPES: Notification['type'][] = BRAND_INFRINGEMENT_NOTIFICATIONS_ENABLED
  ? ['workspace_access', 'brand_infringement']
  : ['workspace_access'];

export function bellNotifications(visible: Notification[]): Notification[] {
  return visible.filter((n) => LISTED_TYPES.includes(n.type));
}

// Cards a list never renders: `dismissed` notifications are filtered out of
// every list, so they must not be counted either.
function countRendered(list: Notification[]): number {
  return list.filter((n) => n.status !== 'dismissed').length;
}

// Pure derivation of per-tab counts from the single visible-notifications set.
// Each count is the number of cards the matching list actually renders — read
// ones included — so the bell badge equals what the user sees in the all tab.
// Non-notification cards rendered alongside them in the all tab (pending
// invitations, client-side alerts) are passed in by the caller.
export function computeTabCounts(
  visible: Notification[],
  extraCards: { invitations?: number; alerts?: number } = {},
) {
  const { invitations = 0, alerts = 0 } = extraCards;
  const listed = bellNotifications(visible);
  return {
    all: countRendered(listed) + invitations + alerts,
    brandInfringement: countRendered(filterByType(listed, 'brand_infringement')),
  };
}
